<template>
  <div class="supplier">
    <v-container class="ma-2">


<detail-card
  title="Προμηθευτής"
  :cid="$route.params.id"
  api="/suppliers/info/"
  >
  <template v-slot:tabsleft>
      <v-btn
        color="primary"
        dense
        @click="invodialog=true"
      >
      <v-icon>mdi-file-document</v-icon>
      </v-btn>
     <invoice-dialog :cid="$route.params.id" :dialog.sync="invodialog" />
      <v-btn
        color="primary"
        dark
        @click="paymdialog=true"
      >
      <v-icon>mdi-cash-register</v-icon>
      </v-btn>
     <payment-dialog :cid="$route.params.id" :dialog.sync="paymdialog" apipath="suppliers/debits" />
  </template>

  <template v-slot:tabsright>
  </template>
</detail-card>
 <v-sheet
      color="white"
      class="ma-3"
      elevation="2">
       <v-tabs show-arrows>
          <v-tab replace :to="{ name: 'distributor-info' }">Πληρωμες</v-tab>
          <v-tab replace :to="{ name: 'distributor-invoices' }">Τιμολογια</v-tab>
          <v-tab replace :to="{ name: 'distributor-aade-invoices' }">ΑΑΔΕ</v-tab>
          <v-tab replace :to="{ name: 'distributor-accounts' }">Λογαριασμοι</v-tab>
          <v-tab replace :to="{ name: 'distributor-orders' }">Παραγγελιες</v-tab>
          <v-tab replace :to="{ name: 'distributor-preorders' }">Προπαραγγελιες</v-tab>
          <v-tab replace :to="{ name: 'distributor-balance' }">Υπολοιπο</v-tab>
          <v-tab replace :to="{ name: 'distributor-sales' }">Πωλησεις</v-tab>
          <v-tab replace :to="{ name: 'distributor-purchases' }">Αγορές</v-tab>
        </v-tabs>
      </v-sheet>
 <router-view></router-view>

    </v-container>
  </div>
</template>

<script>
import DetailCard from '../../components/DetailCard.vue';
import InvoiceDialog from '../../components/InvoiceDialog.vue';
import PaymentDialog from '../../components/PaymentDialog.vue';

export default {
  components: {
    DetailCard,
    InvoiceDialog,
    PaymentDialog,
  },
  data() {
    return {
      expanded: [],
      invodialog: false,
      paymdialog: false,
      loading: true,
      search: '',
      customer_id: this.$route.params.id,
    }
  },
  async created() {
    },
  methods: {

  }
}
</script>
